// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppc-dialog.MuiPaper-root,
.ppc-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  display: flex !important;
  flex-direction: column;
  max-height: calc(
    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  ) !important;
  margin: 12px !important;
  background: var(--surface-color, #111827) !important;
  color: var(--text-color, #f9fafb) !important;
  color-scheme: light dark;
  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;
}

.ppc-dialog--light {
  background: #ffffff !important;
  color: #111827 !important;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16) !important;
}

.ppc-dialog--light .ppc__lead,
.ppc-dialog--light .ppc__hint,
.ppc-dialog--light .ppc__meta,
.ppc-dialog--light .ppc__btn--later {
  color: #4b5563;
}

.ppc-dialog--light .ppc__card {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, #fff);
}

.ppc {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: inherit;
  padding: 0;
}

.ppc__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 24px 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ppc__hero {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);
  color: var(--brand-primary, #0877bc);
}

.ppc__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.ppc__lead,
.ppc__hint {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--text-secondary, #9ca3af);
}

.ppc__card {
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));
}

.ppc__when {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.ppc__session {
  margin: 0;
  font-weight: 700;
  font-size: 1.02rem;
}

.ppc__meta {
  margin: 6px 0 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.86rem;
  color: var(--text-secondary, #9ca3af);
}

.ppc__error {
  margin: 0;
  color: #d97706;
  font-size: 0.88rem;
}

.dark-mode .ppc__error {
  color: #fbbf24;
}

.ppc__actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 20px max(18px, calc(12px + env(safe-area-inset-bottom, 0px)));
  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));
  background: inherit;
}

.ppc__btn {
  font: inherit;
  border: 0;
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 650;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease;
}

.ppc__btn:not(:disabled):hover {
  transform: scale(1.01);
}

.ppc__btn:not(:disabled):active {
  transform: scale(0.98);
}

.ppc__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ppc__btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.ppc__btn--yes {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.ppc__btn--no {
  background: color-mix(in srgb, #ef4444 14%, var(--surface-color));
  color: var(--text-color);
  border: 1px solid color-mix(in srgb, #ef4444 35%, transparent);
}

.ppc__btn--later {
  background: transparent;
  color: var(--text-secondary, #9ca3af);
}

@media (max-width: 600px) {
  .ppc-dialog.MuiPaper-root,
  .ppc-dialog {
    margin: 8px !important;
    width: calc(100% - 16px) !important;
    max-height: calc(
      100dvh - 16px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
    ) !important;
  }

  .ppc__body {
    padding: 18px 16px 10px;
    gap: 10px;
  }

  .ppc__title {
    font-size: 1.12rem;
  }

  .ppc__actions {
    padding: 8px 16px max(16px, calc(10px + env(safe-area-inset-bottom, 0px)));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayerPresenceConfirmDialog.css"],"names":[],"mappings":"AAAA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB;;cAEY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,4CAA4C;EAC5C,wBAAwB;EACxB,2EAA2E;AAC7E;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8EAA8E;EAC9E,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gEAAgE;EAChE,sFAAsF;AACxF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0EAA0E;EAC1E,oEAAoE;EACpE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,wBAAwB;EACxB,8DAA8D;AAChE;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE;;IAEE,sBAAsB;IACtB,mCAAmC;IACnC;;gBAEY;EACd;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0EAA0E;EAC5E;AACF","sourcesContent":[".ppc-dialog.MuiPaper-root,\n.ppc-dialog {\n  border-radius: 20px !important;\n  overflow: hidden;\n  display: flex !important;\n  flex-direction: column;\n  max-height: calc(\n    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  ) !important;\n  margin: 12px !important;\n  background: var(--surface-color, #111827) !important;\n  color: var(--text-color, #f9fafb) !important;\n  color-scheme: light dark;\n  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;\n}\n\n.ppc-dialog--light {\n  background: #ffffff !important;\n  color: #111827 !important;\n  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16) !important;\n}\n\n.ppc-dialog--light .ppc__lead,\n.ppc-dialog--light .ppc__hint,\n.ppc-dialog--light .ppc__meta,\n.ppc-dialog--light .ppc__btn--later {\n  color: #4b5563;\n}\n\n.ppc-dialog--light .ppc__card {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, #fff);\n}\n\n.ppc {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  max-height: inherit;\n  padding: 0;\n}\n\n.ppc__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 24px 20px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ppc__hero {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);\n  color: var(--brand-primary, #0877bc);\n}\n\n.ppc__title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.ppc__lead,\n.ppc__hint {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.ppc__card {\n  padding: 14px 16px;\n  border-radius: 14px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));\n}\n\n.ppc__when {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.ppc__session {\n  margin: 0;\n  font-weight: 700;\n  font-size: 1.02rem;\n}\n\n.ppc__meta {\n  margin: 6px 0 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.86rem;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.ppc__error {\n  margin: 0;\n  color: #d97706;\n  font-size: 0.88rem;\n}\n\n.dark-mode .ppc__error {\n  color: #fbbf24;\n}\n\n.ppc__actions {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 20px max(18px, calc(12px + env(safe-area-inset-bottom, 0px)));\n  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));\n  background: inherit;\n}\n\n.ppc__btn {\n  font: inherit;\n  border: 0;\n  border-radius: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  font-weight: 650;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease;\n}\n\n.ppc__btn:not(:disabled):hover {\n  transform: scale(1.01);\n}\n\n.ppc__btn:not(:disabled):active {\n  transform: scale(0.98);\n}\n\n.ppc__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ppc__btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.ppc__btn--yes {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.ppc__btn--no {\n  background: color-mix(in srgb, #ef4444 14%, var(--surface-color));\n  color: var(--text-color);\n  border: 1px solid color-mix(in srgb, #ef4444 35%, transparent);\n}\n\n.ppc__btn--later {\n  background: transparent;\n  color: var(--text-secondary, #9ca3af);\n}\n\n@media (max-width: 600px) {\n  .ppc-dialog.MuiPaper-root,\n  .ppc-dialog {\n    margin: 8px !important;\n    width: calc(100% - 16px) !important;\n    max-height: calc(\n      100dvh - 16px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n    ) !important;\n  }\n\n  .ppc__body {\n    padding: 18px 16px 10px;\n    gap: 10px;\n  }\n\n  .ppc__title {\n    font-size: 1.12rem;\n  }\n\n  .ppc__actions {\n    padding: 8px 16px max(16px, calc(10px + env(safe-area-inset-bottom, 0px)));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
